export function ScheduleDashboard() {
	return (
		<div className="space-y-4">
			{/* Today header */}
			<div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3">
				<div>
					<h2 className="text-sm font-semibold text-gray-800">Today&apos;s Schedule Overview</h2>
					<p className="mt-0.5 text-xs text-gray-400">Friday, July 4, 2026 &nbsp;·&nbsp; Pittsburgh, PA service area</p>
				</div>
				<div className="flex items-center gap-2">
					<span className="flex items-center gap-1.5 rounded-full bg-pistachioGreen px-2.5 py-1 text-xs font-medium text-primary-500">
						<span className="size-1.5 animate-pulse rounded-full bg-primary-500" />
						Live
					</span>
					<span className="text-xs text-gray-400">Last updated 12:48 PM</span>
				</div>
			</div>

			{/* <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {[
          { label: 'Total Visits', value: kpi.total, icon: <Calendar size={14} />, bg: 'bg-white', text: 'text-gray-700', border: 'border-gray-200' },
          { label: 'Completed', value: kpi.completed, icon: <CheckCircle2 size={14} />, bg: 'bg-[#E4F0EB]', text: 'text-primary-500', border: 'border-[#cad9d1]' },
          { label: 'In Progress', value: kpi.inProgress, icon: <Activity size={14} />, bg: 'bg-[#DBEBFD]', text: 'text-[#19497B]', border: 'border-[#b0ccef]' },
          { label: 'Upcoming', value: kpi.upcoming, icon: <Clock size={14} />, bg: 'bg-[#FFEBC5]', text: 'text-[#774F00]', border: 'border-[#e8d0a0]' },
          { label: 'Missed', value: kpi.missed, icon: <UserX size={14} />, bg: kpi.missed > 0 ? 'bg-[#fdf5f5]' : 'bg-white', text: kpi.missed > 0 ? 'text-red-600' : 'text-gray-400', border: kpi.missed > 0 ? 'border-[#F8D4D4]' : 'border-gray-200' },
          { label: 'Cancelled', value: kpi.cancelled, icon: <AlertCircle size={14} />, bg: 'bg-white', text: 'text-gray-500', border: 'border-gray-200' },
        ].map((card) => (
          <div key={card.label} className={`rounded-lg border ${card.border} ${card.bg} p-3`}>
            <div className={`mb-1.5 flex items-center gap-1.5 ${card.text}`}>{card.icon}<span className="text-[10px] font-semibold uppercase tracking-wide">{card.label}</span></div>
            <div className={`text-2xl font-semibold ${card.text}`}>{card.value}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {[
          { label: 'EVV Exceptions', value: kpi.evvExceptions, sub: 'Pending review', icon: <ShieldAlert size={16} />, accent: 'border-l-[#d32424]', valueCls: kpi.evvExceptions > 0 ? 'text-red-600' : 'text-gray-500', alert: kpi.evvExceptions > 0 },
          { label: 'Unassigned Visits', value: kpi.unassigned, sub: `${UNASSIGNED_VISITS_URGENT} urgent`, icon: <ClipboardList size={16} />, accent: 'border-l-yellow-700', valueCls: kpi.unassigned > 0 ? 'text-yellow-700' : 'text-gray-500', alert: kpi.unassigned > 3 },
          { label: 'Critical Care Gaps', value: kpi.criticalGaps, sub: 'Patients under-visited', icon: <AlertCircle size={16} />, accent: 'border-l-[#d32424]', valueCls: kpi.criticalGaps > 0 ? 'text-[#870B0B]' : 'text-gray-500', alert: kpi.criticalGaps > 0 },
          { label: 'Low Auth Remaining', value: kpi.authLow, sub: '≤5 visits remaining', icon: <Activity size={16} />, accent: 'border-l-[#774F00]', valueCls: kpi.authLow > 0 ? 'text-[#774F00]' : 'text-gray-500', alert: kpi.authLow > 0 },
        ].map((card) => (
          <div key={card.label} className={`rounded-lg border border-l-4 border-gray-200 bg-white ${card.accent} p-4`}>
            <div className="mb-1.5 flex items-center justify-between">
              <span className="text-xs font-medium uppercase tracking-wide text-gray-500">{card.label}</span>
              <span className={card.alert ? card.valueCls : 'text-gray-300'}>{card.icon}</span>
            </div>
            <div className={`text-2xl font-semibold ${card.valueCls}`}>{card.value}</div>
            <div className="mt-0.5 text-xs text-gray-400">{card.sub}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">

        <div className="rounded-lg border border-gray-200 bg-white p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs font-medium uppercase tracking-wide text-gray-500">EVV Compliance (Today)</span>
            <ShieldAlert size={14} className="text-gray-400" />
          </div>
          <div className="mb-3 flex items-end gap-2">
            <span className={`text-2xl font-semibold ${kpi.evvCompliance >= 95 ? 'text-primary-500' : kpi.evvCompliance >= 88 ? 'text-elysiumGold' : 'text-maximumRed'}`}>{kpi.evvCompliance}%</span>
            <span className={`mb-0.5 flex items-center gap-0.5 text-xs ${kpi.evvCompliance >= 95 ? 'text-primary-500' : 'text-elysiumGold'}`}>
              {kpi.evvCompliance >= 95 ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
              Target: 95%
            </span>
          </div>
          <div className="h-2 overflow-hidden rounded-full bg-gray-100">
            <div className={`h-full rounded-full transition-all ${kpi.evvCompliance >= 95 ? 'bg-primary-500' : kpi.evvCompliance >= 88 ? 'bg-elysiumGold' : 'bg-maximumRed'}`} style={{ width: `${kpi.evvCompliance}%` }} />
          </div>
          <p className="mt-2 text-[11px] text-gray-400">{kpi.evvExceptions} exception{kpi.evvExceptions !== 1 ? 's' : ''} pending review</p>
        </div>


        <div className="rounded-lg border border-gray-200 bg-white p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs font-medium uppercase tracking-wide text-gray-500">Clinician Status</span>
            <Users size={14} className="text-gray-400" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { label: 'Available', count: kpi.available, cls: 'text-primary-500', dot: 'bg-primary-500' },
              { label: 'On Visit', count: kpi.onVisit, cls: 'text-[#19497B]', dot: 'bg-[#19497B]' },
              { label: 'On Call', count: CLINICIANS.filter((c) => c.status === 'On Call').length, cls: 'text-yellow-700', dot: 'bg-text-yellow-700' },
              { label: 'Off Duty', count: CLINICIANS.filter((c) => c.status === 'Off Duty').length, cls: 'text-gray-400', dot: 'bg-gray-300' },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-2">
                <span className={`size-2 shrink-0 rounded-full ${s.dot}`} />
                <span className="text-xs text-gray-600">{s.label}</span>
                <span className={`ml-auto text-sm font-semibold ${s.cls}`}>{s.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-xs font-medium uppercase tracking-wide text-gray-500">Day Progress</span>
            <TrendingUp size={14} className="text-gray-400" />
          </div>
          <div className="mb-2 text-xs text-gray-500">
            {kpi.completed} of {kpi.total} visits complete ({Math.round((kpi.completed / kpi.total) * 100)}%)
          </div>
          <div className="flex h-3 overflow-hidden rounded-full bg-gray-100">
            <div className="h-full rounded-l-full bg-primary-500 transition-all" style={{ width: `${(kpi.completed / kpi.total) * 100}%` }} />
            <div className="h-full bg-[#19497B] transition-all" style={{ width: `${(kpi.inProgress / kpi.total) * 100}%` }} />
            <div className="h-full bg-elysiumGold transition-all" style={{ width: `${(kpi.upcoming / kpi.total) * 100}%` }} />
            <div className="h-full rounded-r-full bg-maximumRed transition-all" style={{ width: `${((kpi.missed + kpi.cancelled) / kpi.total) * 100}%` }} />
          </div>
          <div className="mt-2 flex items-center gap-3">
            {[{ c: 'bg-primary-500', l: 'Done' }, { c: 'bg-[#19497B]', l: 'Active' }, { c: 'bg-text-yellow-700', l: 'Upcoming' }, { c: 'bg-[#d32424]', l: 'Missed' }].map((l) => (
              <span key={l.l} className="flex items-center gap-1 text-[10px] text-gray-400">
                <span className={`size-1.5 rounded-full ${l.c}`} />{l.l}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white">
        <div className="border-b border-gray-100 px-4 py-2.5">
          <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-700">Field Staff — Current Status</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50">
                {['Clinician', 'Status', 'Zone', 'Current Assignment', 'Visits (Today)', 'Next Available'].map((h) => (
                  <th key={h} className="whitespace-nowrap px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-gray-400">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {CLINICIANS.map((c) => (
                <tr key={c.id} className="transition-colors hover:bg-gray-50">
                  <td className="px-3 py-2.5">
                    <div className="font-medium text-gray-800">{c.name}, {c.credentials}</div>
                    <div className="text-[11px] text-gray-400">{c.disciplines.join(' / ')}</div>
                  </td>
                  <td className="px-3 py-2.5">
                    <span className={`inline-flex items-center gap-1 rounded px-2 py-0.5 text-[10px] font-semibold ${
                      c.status === 'Available' ? 'bg-pistachioGreen text-primary-500' :
                      c.status === 'On Visit' ? 'bg-cloudless text-[#19497B]' :
                      c.status === 'On Call' ? 'bg-apricotYogurt text-mustard' :
                      'bg-gray-100 text-gray-500'
                    }`}>
                      <span className={`size-1.5 rounded-full ${
                        c.status === 'Available' ? 'bg-primary-500' :
                        c.status === 'On Visit' ? 'bg-[#19497B]' :
                        c.status === 'On Call' ? 'bg-elysiumGold' : 'bg-gray-400'
                      }`} />
                      {c.status}
                    </span>
                  </td>
                  <td className="px-3 py-2.5 text-gray-600">{c.zone}</td>
                  <td className="px-3 py-2.5 text-gray-600">{c.currentPatient || <span className="text-gray-300">—</span>}</td>
                  <td className="px-3 py-2.5">
                    <span className="font-medium text-gray-700">{c.visitsToday}</span>
                    <span className="text-gray-400"> / {c.visitsScheduled}</span>
                  </td>
                  <td className="px-3 py-2.5 text-gray-600">{c.nextAvailable || <span className="text-gray-300">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
		  </div>
		   */}
		</div>
	);
}

const UNASSIGNED_VISITS_URGENT = 2;
